import calendarReducer from './calendar';
import {initialState} from './calendar';

export default {
  calendarStore: calendarReducer,
};

export const initialStates = {
  calendarState: initialState,
};
